/* eslint-disable */

window.field_translations = {
    "ABREV": "Abreviatura",
    "Area_km2": "Área (km ²)",
    "BACIA": "Bacia",
    "CLASSES_UT": "Classe utilitária",
    "CLASSE_GEN": "Classe genética",
    "COD": "Código",
    "DESCRICAO": "Descrição",
    "EMPRESA": "Empresa",
    "ESTRUTURA": "Estrutura",
    "FONTE": "Fonte",
    "IGALAT": "Latitude",
    "IGALONG": "Longitude",
    "IMPORTANCI": "Grau de importância",
    "Latitude": "Latitude",
    "Longitude": "Longitude",
    "MORFOLOGIA": "Morfologia",
    "MUNICIPIO": "Município",
    "Mesorreg": "Mesorregião",
    "Municipio": "Município",
    "NM_NOME": "Nome",
    "NOME": "Nome",
    "PONTO": "Ponto de campo",
    "POP_2016": "População (2016)",
    "PROVINCIA": "Província",
    "ROCHAS_ENC": "Rocha encaixante",
    "ROCHAS_HOS": "Rocha hospedeira",
    "SITUACAO_M": "Situação",
    "STATUS_ECO": "Status econômico",
    "STAT_ECO": "Status econômico",
    "SUBSTANCIA": "Substância",
    "TEXTURAS": "Textura",
    "TIPOS_ALTE": "Tipos de alteração",
    "TIPO_AFLOR": "Tipo de afloramento",
    "TOPONIMIA": "Toponímia",
    "br_codigo": "Código",
    "ds_legenda": "Situação",
    "ds_local_f": "Ponto final",
    "ds_local_i": "Ponto inicial",
    "ext_km": "Extensão (km)",
    "CLASSE_ROC": "Tipo de rocha",
    "ENTIDADE_T": "Ambiente tectônico",
    "LITOTIPOS": "Litotipo",
    "PERIODO_MA": "Idade máxima",
    "PERIODO_MI": "Idade mínima",
    "SIGLA_MG": "Sigla",
    "UNIDADE": "Unidade"
};

window.articles_metadata = {
    "estanho": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "Estanho_ocorr_MG_WGS84",
        "title": "Estanho",
        "fields": ["COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STAT_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "FONTE"
        ]
    },
    "ferro": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "Ferro_ocorr_MG_WGS84",
        "title": "Ferro",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "fertilizantes-provenientes-de-depositos-sedimentares-de-fosfato-e-potassio-pre-cambrianos": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "Fertilizantes_ocorr_MG_WGS84",
        "title": "Fertilizantes",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "gas-natural": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "GasNatural_ocorr_MG_WGS84",
        "title": "Gás Natural",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "FONTE"
        ]
    },
    "litio": {
        "table_index": 1,
        "table_link_columns": [0],
        "feature_name": "Litio_ocorr_MG_WGS84",
        "title": "Lítio",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "manganes": {
        "table_index": 1,
        "table_link_columns": [0],
        "feature_name": "Manganes_ocorr_MG_WGS84",
        "title": "Manganês",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "recursos-construcao-civil": {
        "table_index": 9,
        "table_link_columns": [0],
        "feature_name": "ConstrucaoCivil_ocorr_MG_WGS84",
        "title": "Recursos para construção civil",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "EMPRESA"
        ]
    },
    "niobio": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "Niobio_ocorr_MG_WGS84",
        "title": "Nióbio",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "tantalo": {
        "table_index": 1,
        "table_link_columns": [0],
        "feature_name": "Tantalo_ocorr_MG_WGS84",
        "title": "Tântalo",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "ouro": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "Ouro_ocorr_MG_WGS84",
        "title": "Ouro",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "agalmatolito": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "Agalmatolito_ocorr_MG_WGS84",
        "title": "Agalmatolito",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "agua-mineral": {
        "table_index": 10,
        "table_link_columns": [0],
        "feature_name": "AguasMinerais_ocorr_MG_WGS84",
        "title": "Águas minerais",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "EMPRESA",

        ]
    },
    "aluminio": {
        "table_index": 2,
        "table_link_columns": [0],
        "feature_name": "Aluminio_ocorr_MG_WGS84",
        "title": "Alumínio",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "argilas-e-materiais-refratarios": {
        "table_index": 1,
        "table_link_columns": [0],
        "feature_name": "Argilas_e_MinRefratarios_ocorr_MG_WGS84",
        "title": "Argilas e minerais refratários",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "cromo": {
        "table_index": 1,
        "table_link_columns": [0],
        "feature_name": "Cromo_ocorr_MG_WGS84",
        "title": "Cromo",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "diamante": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "Diamante_ocorr_MG_WGS84",
        "title": "Diamante",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Longitude",
            "Latitude",
            "CLASSES_UT",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "PONTO"
        ]
    },
    "recursos-industria-ceramica-e-vidreira": {
        "table_index": 8,
        "table_link_columns": [0],
        "feature_name": "CeramicaVidro_ocorr_MG_WGS84",
        "title": "Rec. indústria cerâmica",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "EMPRESA"
        ]
    },
    "recursos-industria-farmaceutica": {
        "table_index": 5,
        "table_link_columns": [0],
        "feature_name": "FarmaceuticosCosmeticos_ocorr_MG_WGS84",
        "title": "Rec. indústria farmacêutica",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "EMPRESA"
        ]
    },
    "fertilizantes": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "Fertilizantes_ocorr_MG_WGS84",
        "title": "Fertilizantes",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "gemas-e-minerais-raros": {
        "table_index": 1,
        "table_link_columns": [0],
        "feature_name": "GemasMinRaros_ocorr_MG_WGS84",
        "title": "Gemas e minerais raros",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "PONTO"
        ]
    },
    "grafita": {
        "table_index": 1,
        "table_link_columns": [0],
        "feature_name": "Grafita_ocorr_MG_WGS84",
        "title": "Grafita",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "niquel": {
        "table_index": 1,
        "table_link_columns": [0],
        "feature_name": "NiquelCobalto_ocorr_MG_WGS84",
        "title": "Níquel e cobalto",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "minerais-energeticos": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "RecEnergeticos_ocorr_MG_WGS84",
        "title": "Minerais energéticos",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "rochas-carbonaticas": {
        "table_index": 2,
        "table_link_columns": [0],
        "feature_name": "RochasCarbonaticas_ocorr_MG_WGS84",
        "title": "Rochas carbonáticas",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "EMPRESA"
        ]
    },
    "rochas-industriais": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "RochasIndustriais_ocorr_MG_WGS84",
        "title": "Rochas industriais",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "EMPRESA"
        ]
    },
    "rochas-ornamentais": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "RochasOrnamentais_ocorr_MG_WGS84",
        "title": "Rochas ornamentais",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "terras-raras": {
        "table_index": 3,
        "table_link_columns": [0],
        "feature_name": "TerrasRaras_ocorr_MG_WGS84",
        "title": "Terras raras",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    },
    "titanio": {
        "table_index": 1,
        "table_link_columns": [0],
        "feature_name": "Titanio_ocorr_MG_WGS84",
        "title": "Titânio",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "IMPORTANCI",
            "STATUS_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR"
        ]
    }
    ,
    "zinco-chumbo": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "ZincoChumbo_ocorr_MG_WGS84",
        "title": "Zinco e chumbo",
        "fields": [
            "COD",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STAT_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "FONTE"
        ]
    },
    "distribuicao-de-jazidas-e-minas": {
        "table_index": 0,
        "table_link_columns": [0],
        "feature_name": "Distribuicao_de_jazidas_e_minas",
        "title": "Distribuição de Jazidas e Minas",
        "key_field": "NUM",
        "fields": [
            "NUM",
            "ABREV",
            "SUBSTANCIA",
            "TOPONIMIA",
            "MUNICIPIO",
            "Latitude",
            "Longitude",
            "CLASSES_UT",
            "CLASSE_GEN",
            "DESCRICAO",
            "IMPORTANCI",
            "STAT_ECO",
            "SITUACAO_M",
            "PROVINCIA",
            "ROCHAS_HOS",
            "ROCHAS_ENC",
            "MORFOLOGIA",
            "TEXTURAS",
            "TIPOS_ALTE",
            "TIPO_AFLOR",
            "FONTE"
        ]
    }
};



// WEBPACK FOOTER //
// ./scripts/common_metadata.js